import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  FormField,
  DashboardModule,
 } from '@campaignhub/suit-theme'

import useClientsV4 from '@hooks/useClientsV4'

import InfiniteSelect from '@components/InfiniteSelect'

const AgentDetail = (props) => {
  const { userForm, customErrors } = props
  const {
    entityState: {
      agent,
    },
    setEntityState,
  } = userForm

  const {
    filteredClientsV4,
    hasMore: clientHasMore,
    loading: clientLoading,
    callbacks: {
      loadInitialPage: loadInitialClientPage,
      loadNextPage: loadNextClientPage,
    },
  } = useClientsV4()

  useEffect(() => {
    loadInitialClientPage()
  }, [])

  const clientOptions = useMemo(
    () => filteredClientsV4.map(client => ({
      ...client,
      label: `${client.name} (${client.number})`,
    })),
    [filteredClientsV4],
  )

  return (
    <DashboardModule title="Agent Information">
      <Box flexDirection="column" padding="large">
        <Box
          flexDirection={['column', 'row']}
          marginBottom={[0, 'large']}
          width={['100%', 'calc(50% - 4px)']}
        >
          <FormField
            boxProps={{ flex: 1 }}
            label="Office"
            errorMessage={customErrors['agent.office']}
          >
            <InfiniteSelect
              name="agent.office"
              value={agent.office}
              onChange={(val) => {
                agent.office = val
                setEntityState({ agent })
              }}
              options={clientOptions}
              onLoadMore={loadNextClientPage}
              hasMore={clientHasMore}
              loading={clientLoading}
              labelKey="label"
              valueKey="id"
            />
          </FormField>
        </Box>
      </Box>
    </DashboardModule>
    )
 }
 AgentDetail.propTypes = {
  userForm: PropTypes.object,
  customErrors: PropTypes.array,
  callbacks: PropTypes.object,
}

  export default AgentDetail
